/*
  Only needed to make type checking easier.
  Is in use even if it is "empty".

  Inheriting this class means "I am not empty - display me".

  As I'm writing this it is used by profiles (be it user or companyprofile) to determine if a section is empty and should be displayed in external view.
*/
export class AtomarDisplayUnit {}
